import  baseHttp  from '@/services/baseHttp';
export default{
    async getAppData(context,payload){
        let response=await baseHttp.post(`getAppData/${context.rootState.zendesk.zendeskInfo.ticket.id}`,payload);
        if(response.data && response.data.Success){
            context.commit('setAppData',response.data);
            
            context.commit('zendesk/setZendeskUser',response.data.Data.userInfo,{ root: true })
            context.commit('zendesk/setZendeskAttachments',response.data.Data.attachments,{ root: true })
            context.commit('zendesk/setZendeskLinkedItems',response.data.Data.linkedTickets.map(d=>d.workItemId).toString(),{ root: true })
        }else{
            context.commit('setAppData',response.data);
        }
    }
};